module.exports = __webpack_public_path__ + "static/media/head.bca79b3e.png";